/* SynEra Innovations · Product page URL cleanup + email deeplink
 *
 * Two behaviors, both gated on /products/* pages:
 *
 * 1. URL cleanup — strips ?variant=N so the address bar stays clean.
 *    SynEra currently ships a single variant per product, so Shopify's
 *    default variant param is cosmetic noise. The Add-to-Cart form has
 *    the variant ID hardcoded at server-render via the hidden id input,
 *    so stripping has zero functional impact on cart submission.
 *    Revisit when a multi-variant product launches — the strip should
 *    become conditional on product.variants.size === 1 at that point.
 *
 * 2. Email deeplink — when ?rating=N (1-5) is in the URL (source:
 *    Klaviyo Day 14 review collection email), opens the theme review
 *    modal (.shop-reviews-write) and pre-selects N stars. Then strips
 *    ?rating so a page reload doesn't re-open the modal.
 *
 * Bails silently on any URL that doesn't match. Direct, search, and
 * social traffic see zero behavior change other than the cosmetic
 * variant-param strip.
 *
 * Selectors verified against the live theme on 2026-05-08.
 */
(function () {
  'use strict';

  // Only run on product pages
  if (!/^\/products\//.test(window.location.pathname)) return;

  /* ---- 1. Cosmetic URL cleanup: strip ?variant=N -------------------- */

  function stripVariantParam() {
    if (window.location.search.indexOf('variant=') === -1) return;
    try {
      var cleanedSearch = window.location.search
        .replace(/[?&]variant=\d+/g, '')
        .replace(/^&/, '?');
      if (cleanedSearch === '?') cleanedSearch = '';
      var cleanedUrl = window.location.pathname + cleanedSearch + window.location.hash;
      window.history.replaceState({}, document.title, cleanedUrl);
    } catch (e) { /* no-op */ }
  }

  // Strip immediately on script load.
  stripVariantParam();

  // Persistent watcher for the first 10 seconds after page load.
  // Some third-party app scripts (Apstle Subscription, payment-button
  // SDKs, etc.) initialize async and re-sync the URL with the selected
  // variant well after our initial strip. The watcher polls every 100ms
  // and only acts when the URL actually changes — so it's lightweight
  // and self-terminating.
  var lastSeenSearch = window.location.search;
  var stripWatcher = setInterval(function () {
    if (window.location.search !== lastSeenSearch) {
      lastSeenSearch = window.location.search;
      stripVariantParam();
      // After our strip, lastSeenSearch reflects the cleaned URL so we
      // don't re-fire on our own change.
      lastSeenSearch = window.location.search;
    }
  }, 100);
  setTimeout(function () {
    clearInterval(stripWatcher);
  }, 10000);

  /* ---- 2. Email deeplink: ?rating=N → open modal + preselect ------- */

  // Re-read location.search since the variant strip above mutated it.
  var params = new URLSearchParams(window.location.search);
  var rating = parseInt(params.get('rating'), 10);

  // Validate the rating param
  if (!Number.isInteger(rating) || rating < 1 || rating > 5) return;

  // Note: we previously gated on a #judgeme_product_reviews hash for safety,
  // but Shopify's variant-redirect strips the hash on first load. The
  // ?rating=N param itself is specific enough to act as the signal — no
  // other URL pattern on the site uses it.

  function openModalAndSelectRating() {
    var opener = document.querySelector('.shop-reviews-write');
    if (!opener) return false;
    opener.click();

    // Modal mounts synchronously in the theme; one frame is enough.
    requestAnimationFrame(function () {
      var starLabel = rating === 1 ? '1 star' : rating + ' stars';
      var star = document.querySelector(
        '.rv-modal-card .rv-stars-input button[aria-label="' + starLabel + '"]'
      );

      if (star) {
        star.click();
      } else {
        // Fallback: write directly to the hidden rating field
        var ratingField = document.getElementById('rv-rating');
        if (ratingField) {
          ratingField.value = String(rating);
          ratingField.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      // Strip ?rating from the URL so a page reload doesn't re-open the modal.
      try {
        var newSearch = window.location.search
          .replace(/[?&]rating=\d+/g, '')
          .replace(/^&/, '?');
        if (newSearch === '?') newSearch = '';
        var newUrl = window.location.pathname + newSearch + window.location.hash;
        window.history.replaceState({}, document.title, newUrl);
      } catch (e) { /* no-op */ }
    });

    return true;
  }

  // Run when DOM is ready, with a brief poll fallback in case the
  // theme mounts the opener button after DOMContentLoaded.
  function start() {
    if (openModalAndSelectRating()) return;
    var attempts = 0;
    var id = setInterval(function () {
      if (openModalAndSelectRating() || ++attempts > 60) clearInterval(id);
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
